
import React from 'react';
const NewFigures = () => {
    return (
        <div className="NewFigures_container__CCj4S">
            <div className="NewFigures_secHeading__fe2Ki">By the numbers</div>
            <div className="NewFigures_content__YKfOF">
                <div className="NewFigures_box___24DR">
                    <div className="NewFigures_smolBox___7eMU">
                        <span className="NewFigures_digit__AwroR">15</span>
                        <span className="NewFigures_plus__kCylR">+</span>
                    </div>
                    <div className="NewFigures_text__kwuAm">Solutions for Global crises</div>
                </div>
                <div className="NewFigures_line__RP_TF"></div>
                <div className="NewFigures_box___24DR">
                    <div className="NewFigures_smolBox___7eMU">
                        <span className="NewFigures_digit__AwroR">10</span>
                        <span className="NewFigures_plus__kCylR">+</span>
                    </div>
                    <div className="NewFigures_text__kwuAm">University Collaborations</div>
                </div>
                <div className="NewFigures_line__RP_TF"></div>
                <div className="NewFigures_box___24DR">
                    <div className="NewFigures_smolBox___7eMU">
                        <span className="NewFigures_digit__AwroR">25</span>
                        <span className="NewFigures_plus__kCylR">+</span>
                    </div>
                    <div className="NewFigures_text__kwuAm">Employees Worldwide</div>
                </div>
            </div>
        </div>
    );
};

export default NewFigures;